

import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const FETCH_TASK_TRACKING_REQUEST = "FETCH_TASK_TRACKING_REQUEST";
export const FETCH_TASK_TRACKING_SUCCESS = "FETCH_TASK_TRACKING_SUCCESS";
export const FETCH_TASK_TRACKING_FAILURE = "FETCH_TASK_TRACKING_FAILURE";

export const UPDATE_TASK_TRACKING_REMARKS_REQUEST = "UPDATE_TASK_TRACKING_REMARKS_REQUEST";
export const UPDATE_TASK_TRACKING_REMARKS_SUCCESS = "UPDATE_TASK_TRACKING_REMARKS_SUCCESS";
export const UPDATE_TASK_TRACKING_REMARKS_FAILURE = "UPDATE_TASK_TRACKING_REMARKS_FAILURE";



// // Fetch All Task Tracking Data with filters and pagination
// export const fetchAllTaskTracking = (params = {}) => {
//   return async (dispatch) => {
//     dispatch({ type: FETCH_TASK_TRACKING_REQUEST });

//     const token = localStorage.getItem("token");
//     const query = new URLSearchParams(params).toString();

//     try {
//       const response = await axios.get(
//         `${BASE_URL}/v1/api/admin/getAllTaskTrackingData?${query}`,
//         { headers: { Authorization: token } }
//       );

//       if (response?.data?.meta?.status) {
//         dispatch({
//           type: FETCH_TASK_TRACKING_SUCCESS,
//           payload: response.data,
//         });
//       } else {
//         dispatch({
//           type: FETCH_TASK_TRACKING_FAILURE,
//           payload: response?.data?.meta?.message || "Failed to fetch data.",
//         });
//       }
//     } catch (error) {
//       dispatch({
//         type: FETCH_TASK_TRACKING_FAILURE,
//         payload: error?.response?.data?.meta?.message || error.message,
//       });
//     }
//   };
// }
// Fetch All Task Tracking Data with filters and pagination
export const fetchAllTaskTracking = (params = {}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_TASK_TRACKING_REQUEST });

    const token = localStorage.getItem("token");

    // Set default values for missing params
    const {
      page = 1,
      limit = 10,
      // district = "",
      // municipality = "",
      fromDate = "",
      toDate = "",
      search = "",
      designation = "",
      status = ""
    } = params;

    try {
      const response = await axios.get(
        `${BASE_URL}/v1/api/admin/getAllTaskTrackingData`,
        {
          headers: { Authorization: token },
          params: {
            page,
            limit,
            // district,
            // municipality,
            fromDate: fromDate || null,
            toDate: toDate || null,
            search,
            designation,
            status
          }
        }
      );

      if (response?.data?.meta?.status) {
        dispatch({
          type: FETCH_TASK_TRACKING_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_TASK_TRACKING_FAILURE,
          payload: response?.data?.meta?.message || "Failed to fetch data.",
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_TASK_TRACKING_FAILURE,
        payload: error?.response?.data?.meta?.message || error.message,
      });
    }
  };
};



// Update Remarks
export const updateTaskTrackingRemarks = (id, remarks) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_TASK_TRACKING_REMARKS_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${BASE_URL}/v1/api/admin/update-task-tracking-remarks`,
        {
          task_tracking_id: id,
          task_tracking_remarks: remarks,
        },
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.meta?.status) {
        dispatch({ type: UPDATE_TASK_TRACKING_REMARKS_SUCCESS });
        toast.success("Remarks updated successfully");
        dispatch(fetchAllTaskTracking());
      } else {
        dispatch({
          type: UPDATE_TASK_TRACKING_REMARKS_FAILURE,
          payload: response?.data?.meta?.message || "Update failed.",
        });
        toast.error(response?.data?.meta?.message || "Failed to update remarks");
      }
    } catch (error) {
      dispatch({
        type: UPDATE_TASK_TRACKING_REMARKS_FAILURE,
        payload: error?.response?.data?.meta?.message || error.message,
      });
      toast.error(error?.response?.data?.meta?.message || "Something went wrong");
    }
  };
};
